import React from 'react';
import { CheckIcon } from 'lucide-react';
interface AdvertorialBulletPointsProps {
  headline: string;
  points: string[];
}
export const AdvertorialBulletPoints: React.FC<AdvertorialBulletPointsProps> = ({
  headline,
  points
}) => {
  return <section className="w-full py-8 md:py-16 bg-blue-50" data-id="element-5">
      <div className="container mx-auto px-4" data-id="element-6">
        <h2 className="text-2xl md:text-4xl font-bold text-blue-900 mb-8 text-center" data-id="element-7">
          {headline}
        </h2>
        <ul className="space-y-4 max-w-2xl mx-auto" data-id="element-8">
          {points.map((point, index) => <li key={index} className="flex items-start" data-id="element-9">
              <span className="flex-shrink-0 h-6 w-6 bg-green-500 rounded-full flex items-center justify-center mr-3 mt-1" data-id="element-10">
                <CheckIcon className="h-4 w-4 text-white" data-id="element-11" />
              </span>
              <span className="text-lg md:text-xl text-gray-700" data-id="element-12">{point}</span>
            </li>)}
        </ul>
      </div>
    </section>;
};